
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cont/inregistrare",
      function () {
        return require("private-next-pages/cont/inregistrare.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cont/inregistrare"])
      });
    }
  